<template>
  <div class="themed-percent-input">
    <themed-input
      :id="id"
      :value="displayValue"
      :disabled="disabled"
      :readonly="readonly"
      :error="error"
      :placeholder="placeholder"
      :aria-invalid="ariaInvalid"
      :aria-describedby="ariaDescribedby"
      :aria-required="ariaRequired"
      type="text"
      class="text-right"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
    />
    <span class="themed-percent-input__suffix">%</span>
  </div>
</template>

<script>
import ThemedInput from '../ThemedInput.vue';

export default {
  name: 'ThemedPercentInput',
  components: {
    ThemedInput
  },
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: [Number, String],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    ariaInvalid: {
      type: String,
      default: null
    },
    ariaDescribedby: {
      type: String,
      default: null
    },
    ariaRequired: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      displayValue: '',
      isFocused: false
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (!this.isFocused) {
          this.displayValue = this.formatValue(newValue);
        }
      }
    }
  },
  methods: {
    handleInput(value) {
      // Remove all non-numeric characters except decimal point and minus
      const cleaned = value.replace(/[^0-9.-]/g, '');
      this.displayValue = cleaned;
      this.$emit('input', cleaned);
    },
    handleFocus(event) {
      this.isFocused = true;
      // Select all text on focus
      setTimeout(() => {
        event.target.select();
      }, 0);
      this.$emit('focus', event);
    },
    handleBlur(event) {
      this.isFocused = false;
      const formatted = this.formatValue(this.value);
      this.displayValue = formatted;
      this.$emit('blur', event);
    },
    formatValue(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      
      // Parse the value
      const num = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
      
      if (isNaN(num)) {
        return '';
      }
      
      // Format with 2 decimal places for percentages
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }
};
</script>
